import { PosScreen } from "@/components/pos/PosScreen";

export default function PosPage() {
  return <PosScreen />;
}
